<template>
  <v-card outlined class="pa-3">
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          outlined
          label="שם מבצע"
          v-model="item.campaign_name"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="4">
        <v-text-field
          outlined
          label="סכום מינימלי לקבלת הנחה"
          type="number"
          v-model.number="item.total_to_get_discount"
          :rules="[(v) => !!v || 'חובה']"
        >
          <template slot="label">
            <strong class="red--text">*</strong>
            סכום מינימלי
          </template>
        </v-text-field>
      </v-col>

      <v-col cols="12" sm="4">
        <v-text-field
          outlined
          label="אחוז הנחה על משלוח"
          type="number"
          v-model.number="item.delivery_discount_percentage"
          :rules="[(v) => v >= 0 && v <= 100 || '0-100']"
        >
          <template slot="label">
            <strong class="red--text">*</strong>
            % הנחה
          </template>
        </v-text-field>
      </v-col>

      <v-col cols="12" sm="4">
        <v-menu
          v-model="menu_1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="item.start_date"
              prepend-inner-icon="mdi-calendar"
              readonly
              :rules="[(v) => !!v || 'חובה']"
              v-bind="attrs"
              v-on="on"
              outlined
            >
              <template slot="label">
                <strong class="red--text">*</strong>
                תאריך התחלה
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="item.start_date"
            @input="menu_1 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" sm="4">
        <v-menu
          v-model="menu_2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="item.end_date"
              prepend-inner-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              outlined
              :rules="[
                () => !!compare_dates || 'נא לסמן תאריך אחרי תאריך התחלה',
                (v) => !!v || 'חובה',
              ]"
            >
              <template slot="label">
                <strong class="red--text">*</strong>
                עד תאריך
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="item.end_date"
            @input="menu_2 = false"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" sm="4">
        <v-switch
          v-model="item.status"
          :label="item.status ? 'פעיל' : 'לא פעיל'"
          color="success"
          hide-details
        ></v-switch>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <h3 class="mb-3">מותגים במבצע</h3>
        <v-autocomplete
          v-model="item.brands"
          :items="brands_list"
          item-value="id"
          item-text="name"
          label="בחר מותגים"
          outlined
          multiple
          chips
          deletable-chips
          return-object
        >
          <template v-slot:selection="{ item }">
            <v-chip close @click:close="remove_brand(item.id)">
              <v-avatar left v-if="item.image">
                <img :src="`${$store.state.def_path}/${item.image}`" />
              </v-avatar>
              {{ item.name }}
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-avatar v-if="item.image">
              <img :src="`${$store.state.def_path}/${item.image}`" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: {
    item: Object,
    compare_dates: Boolean,
  },
  data() {
    return {
      menu_1: false,
      menu_2: false,
      brands_list: [],
    };
  },
  mounted() {
    this.get_brands();
  },
  methods: {
    get_brands() {
      this.$store
        .dispatch("public__request", {
          config: {
            url: "brands",
            method: "get",
          },
        })
        .then((res) => {
          this.brands_list = (res.data && res.data.data) || [];
        });
    },
    remove_brand(id) {
      this.item.brands = this.item.brands.filter((b) => b.id !== id);
    },
  },
};
</script>
